import React from 'react';
import { Badge } from './ui/badge';
import { Award, MapPin, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const AboutUsSection = () => {
  const { company, contact } = mockData;

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="about" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <Badge className="bg-blue-900 text-white px-4 py-2 text-sm font-semibold mb-4">
            ABOUT ALF UNIFORM
          </Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Kuwait's Leading Uniform Supplier
          </h2>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 mb-12">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
            <p className="text-lg mb-6">
              <strong className="text-blue-900">Alf Uniform</strong> is Kuwait's premier <strong>ready-made uniform supplier</strong> and custom embroidery specialist, proudly serving businesses across Kuwait since 2017. Located in <strong>Office 23, Floor M1, Ali Tower, Miqab Qibla</strong>, we maintain Kuwait's largest ready-stock inventory of <strong>corporate uniforms, polo shirts, round neck t-shirts, and cargo pants</strong> in over 40 colors and all sizes (XS-4XL, waist 28-44).
            </p>
            
            <p className="text-lg mb-6">
              Our state-of-the-art in-house <strong>embroidery machines, DTF printing, and screen printing</strong> services provide professional logo branding for security companies, restaurants, hospitals, schools, corporate offices, and industrial facilities throughout Kuwait City, Hawalli, Farwaniya, Ahmadi, and Jahra.
            </p>

            <p className="text-lg mb-6">
              We also specialize in <strong>premium hotel embroidery services</strong>, offering custom branding on <strong>towels, bathrobes, bed linens, table linens, napkins,</strong> and other hospitality textiles. Our expert embroidery team ensures hotel-grade quality with elegant logo placement, perfect for luxury hotels, resorts, spas, and hospitality establishments across Kuwait.
            </p>

            <p className="text-lg mb-6">
              Unlike traditional uniform suppliers requiring 2-4 week waiting periods, <strong>Alf Uniform offers 48-hour delivery</strong> with no minimum order requirements, making us the preferred choice for urgent uniform needs. With 250+ satisfied clients including leading Kuwaiti enterprises, we combine premium polycotton and 100% organic cotton fabrics with competitive bulk pricing for orders of 50+, 100+, and 200+ pieces.
            </p>

            <p className="text-lg">
              Whether you need <strong>immediate off-the-shelf uniforms, custom-embroidered workwear,</strong> or <strong>hotel textile embroidery</strong>, our expert team at Alf Uniform delivers unmatched quality and service throughout Kuwait.
            </p>
          </div>
        </div>

        {/* Key Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-xl p-6 shadow-lg text-center border-2 border-blue-900">
            <Award className="h-12 w-12 text-blue-900 mx-auto mb-3" />
            <div className="text-3xl font-bold text-blue-900 mb-2">{company.established}</div>
            <div className="text-gray-700 font-medium">Serving Kuwait Businesses</div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg text-center border-2 border-green-600">
            <div className="text-3xl font-bold text-green-600 mb-2">250+</div>
            <div className="text-gray-700 font-medium">Happy Clients Across Kuwait</div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg text-center border-2 border-amber-600">
            <div className="text-3xl font-bold text-amber-600 mb-2">48 Hours</div>
            <div className="text-gray-700 font-medium">Delivery Available</div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl p-8 text-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="flex flex-col items-center">
              <MapPin className="h-8 w-8 mb-3 text-blue-200" />
              <div className="font-semibold mb-1">Visit Our Showroom</div>
              <div className="text-blue-100 text-sm">{company.location}</div>
            </div>

            <div className="flex flex-col items-center">
              <Phone className="h-8 w-8 mb-3 text-blue-200" />
              <div className="font-semibold mb-1">Call Us</div>
              <a href={`tel:${contact.phone}`} className="text-blue-100 hover:text-white transition-colors">
                {contact.phone}
              </a>
            </div>

            <div className="flex flex-col items-center">
              <Mail className="h-8 w-8 mb-3 text-blue-200" />
              <div className="font-semibold mb-1">Email Us</div>
              <a href={`mailto:${contact.email}`} className="text-blue-100 hover:text-white transition-colors">
                {contact.email}
              </a>
            </div>
          </div>

          <div className="text-center mt-8">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-white text-blue-900 hover:bg-gray-100 px-10 py-6 text-lg font-semibold"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
